import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useHttpClient } from '../providers/httpClient';
import { helpCenterSlice } from '../reducers/helpCenter';
import { useAppDispatch } from '../store';
import { loadArticleById, loadArticleByUri } from '../thunks/articles.thunk';

export const useFetchArticle = () => {
  const httpClient = useHttpClient();
  const { articleId, articleUri } = useParams();
  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();

  useEffect(() => {
    articleId
      ? appDispatch(loadArticleById({ id: articleId!, httpClient }))
      : appDispatch(loadArticleByUri({ uri: articleUri!, httpClient }));

    return () => {
      dispatch(helpCenterSlice.actions.setArticleHeadingVisible(false));
      dispatch(helpCenterSlice.actions.setArticleError(null));
    };
  }, [articleId, articleUri]);
};
